document.addEventListener('DOMContentLoaded', () => {

// Buttons

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
        if(emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
        else prevBtn.setAttribute('disabled', 'disabled')

        if(emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
        else nextBtn.setAttribute('disabled', 'disabled')

        if(!emblaApi.canScrollPrev() && !emblaApi.canScrollNext()) {
            prevBtn.setAttribute('aria-hidden', 'true')
            nextBtn.setAttribute('aria-hidden', 'true')
        } else {
            prevBtn.setAttribute('aria-hidden', 'false')
            nextBtn.setAttribute('aria-hidden', 'false')
        }
    }

    emblaApi
        .on('select', togglePrevNextBtnsState)
        .on('init', togglePrevNextBtnsState)
        .on('reInit', togglePrevNextBtnsState)

    return () => {
        prevBtn.removeAttribute('disabled')
        nextBtn.removeAttribute('disabled')
    }
}

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
        emblaApi.scrollPrev()
    }
    const scrollNext = () => {
        emblaApi.scrollNext()
    }
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
        emblaApi,
        prevBtn,
        nextBtn
    )

    return () => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
    }
}


// Dots

const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = []

    const addDotBtnsWithClickHandlers = () => {
        dotsNode.innerHTML = emblaApi.canScrollNext() ? emblaApi
            .scrollSnapList()
            .map(() => '<button class="ln-carousel-dot" type="button"></button>')
            .join('') : ''
        const scrollTo = (index) => {
            emblaApi.scrollTo(index)
        }
        
        dotNodes = Array.from(dotsNode.querySelectorAll('.ln-carousel-dot'))
        dotNodes.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => scrollTo(index), false)
        })
    }

    const toggleDotBtnsActive = () => {
        const previous = emblaApi.previousScrollSnap()
        const selected = emblaApi.selectedScrollSnap()
        dotNodes[previous]?.classList.remove('ln-carousel-dot-selected')
        dotNodes[selected]?.classList.add('ln-carousel-dot-selected')
    }

    emblaApi
        .on('init', () => {
            addDotBtnsWithClickHandlers()
            toggleDotBtnsActive()
        })
        .on('reInit', () => {
            addDotBtnsWithClickHandlers()
            toggleDotBtnsActive()
        })
        .on('select', toggleDotBtnsActive)

    return () => {
        dotsNode.innerHTML = ''
    }
}

// Autoplay

const addAutoplayProgressListeners = (emblaApi, progressNode) => {
  const progressBarNode = progressNode?.querySelector('[embla-progress-bar]') ?? null
  if(progressBarNode === null) return

  let animationName = ''
  let timeoutId = 0
  let rafId = 0

  const startProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay
    if (!autoplay) return

    const timeUntilNext = autoplay.timeUntilNext()
    if (timeUntilNext === null) return

    if (!animationName) {
      const style = window.getComputedStyle(progressBarNode)
      animationName = style.animationName
    }

    progressBarNode.style.animationName = 'none'
    progressBarNode.style.transform = 'translate3d(0,0,0)'

    rafId = window.requestAnimationFrame(() => {
      timeoutId = window.setTimeout(() => {
        progressBarNode.style.animationName = animationName
        progressBarNode.style.animationDuration = `${timeUntilNext}ms`
      }, 0)
    })

    progressNode.classList.remove('embla-progress--hidden')
  }

  const stopProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay
    if (!autoplay) return

    progressNode.classList.add('embla-progress--hidden')
  }

  emblaApi
    .on('autoplay:timerset', startProgress)
    .on('autoplay:timerstopped', stopProgress)
}


// Carousel

window.emblaCarousels = []
const allCarousels = document.querySelectorAll('[embla-carousel]')
if(allCarousels) {
    allCarousels.forEach(carouselNode => {
        const carouselViewport = carouselNode.querySelector('[embla-viewport]')
        const carouselPrevBtn = carouselNode.querySelector('[embla-prev]')
        const carouselNextBtn = carouselNode.querySelector('[embla-next]')
        const carouselDots = carouselNode.querySelector('[embla-dots]')
        const carouselProgress = carouselNode.querySelector('[embla-progress]')
        const options = carouselViewport.dataset.emblaOptions ? JSON.parse(carouselViewport.dataset.emblaOptions) : {}
        const autoplay = carouselViewport.dataset.emblaAutoplay ? Boolean(carouselViewport.dataset.emblaAutoplay) : false
        const delay = carouselViewport.dataset.emblaDelay ? Number(carouselViewport.dataset.emblaDelay) : 2000

        const carousel = EmblaCarousel(carouselViewport, {
            loop: false, 
            dragFree: true,
            align: 'start',
            containScroll: 'trimSnaps',
            // watchResize: emblaApi => onResize(emblaApi),
            watchDrag: emblaApi => isScrollable(emblaApi),
            ...options
        }, autoplay ? [ EmblaCarouselAutoplay({ delay: delay, playOnInit: autoplay }) ] : [])
        window.emblaCarousels.push(carousel)

        carousel.on('resize', emblaApi => onResize(emblaApi))
        carousel.on('init', emblaApi => {
            emblaApi.emit('resize')
            addAutoplayProgressListeners(emblaApi, carouselProgress)
        })

        const removePrevNextBtnsClickHandlers = carouselNextBtn !== null && addPrevNextBtnsClickHandlers(
            carousel,
            carouselPrevBtn,
            carouselNextBtn
        )
        carousel.on('destroy', removePrevNextBtnsClickHandlers)

        const removeDotBtnsAndClickHandlers = carouselDots !== null && addDotBtnsAndClickHandlers(
            carousel,
            carouselDots
        )

        carousel.on('destroy', removeDotBtnsAndClickHandlers)
    })

    function isScrollable(emblaApi) {
        return emblaApi.internalEngine().scrollSnaps.length > 1
    }

    function onResize(emblaApi) {
        const scrollable = isScrollable(emblaApi)
        if(scrollable) {
            emblaApi.containerNode().style.justifyContent = 'flex-start'
            emblaApi.reInit()
        } else {
            emblaApi.containerNode().style.justifyContent = 'center'
        }
        emblaApi.scrollTo(0, true)
        // true continues to default embla resize callback
        return true 
    }
    
}
// console.log('window.emblaCarousels', window.emblaCarousels)
    
})//DOMContentLoaded